module.exports = __webpack_public_path__ + "static/media/spotify.2edb12dc.png";